export const COLORS = {
  background: 0xFFF8E7,
  primary: 0xFFD93D,
  accent: 0xE63946,
  player: 0x3B82F6,
  text: 0x1a1a1a,
  textMuted: 0x6B7280,
  card: 0xFFFFFF,
  shadow: 0xD1D5DB,
};
export const PLAYER_WIDTH = 50;
export const PLAYER_HEIGHT = 50;
export const PLAYER_COLOR = COLORS.player;
export const PLAYER_SPEED = 8;
export const BLOCK_WIDTH = 40;
export const BLOCK_HEIGHT = 40;
export const BLOCK_COLOR = COLORS.accent;
export const INITIAL_FALL_SPEED = 3;
export const MAX_FALL_SPEED = 12;
export const SPEED_INCREMENT = 0.001;
export const INITIAL_SPAWN_INTERVAL = 1200;
export const MIN_SPAWN_INTERVAL = 400;
export const SPAWN_INTERVAL_DECREMENT = 0.5;
export const SCORE_PER_SECOND = 10;
export const DIFFICULTY_SCALE = {
  speedMultiplier: 1.05,
  spawnMultiplier: 0.98,
  maxSpeed: MAX_FALL_SPEED,
  minSpawnInterval: MIN_SPAWN_INTERVAL,
};
export const PARTICLE_CONFIG = {
  count: 30,
  speed: 7,
  lifetime: 1200,
  colors: [COLORS.accent, COLORS.primary, 0xFFFFFF, 0x60A5FA],
  sizeVariance: 4,
};
export const SCREEN_SHAKE_CONFIG = {
  intensity: 12,
  duration: 400,
  decay: 0.92,
  minThreshold: 0.5,
};
export const AUDIO_CONFIG = {
  hit: {
    frequency: 150,
    duration: 0.3,
    volume: 0.6,
    type: 'sawtooth' as OscillatorType,
  },
  score: {
    frequency: 880,
    duration: 0.15,
    volume: 0.3,
    type: 'sine' as OscillatorType,
  },
  dodge: {
    frequency: 440,
    duration: 0.1,
    volume: 0.2,
    type: 'triangle' as OscillatorType,
  },
};
export const WORLD_CONFIG = {
  baseWidth: 375,
  baseHeight: 667,
  groundHeight: 60,
};